import { Badge } from '@/components/ui/badge';
import type { SubscriptionTier } from '@/types';
import { cn } from '@/lib/utils';

interface TierBadgeProps {
  tier: SubscriptionTier;
  className?: string;
}

export function TierBadge({ tier, className }: TierBadgeProps) {
  const tierConfig = {
    FREE: {
      label: 'Free',
      variant: 'secondary' as const,
      className: 'bg-background text-secondary border-secondary/60'
    },
    ACTIVE: {
      label: 'Active',
      variant: 'default' as const,
      className: 'bg-background text-success border-success/60'
    }
  };

  const config = tierConfig[tier];

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, className)}
    >
      {config.label}
    </Badge>
  );
}
